export const Form_Qns = [
  {
    type: 'text',
    label: 'Street Address',
    question: 'Street Address',
    name: 'StreetAddress',
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'text',
    label: 'Unit Number',
    question: 'Unit Number',
    name: 'UnitNumber',
    validations: [],
  },

  {
    type: 'text',
    label: 'City',
    question: 'City',
    name: 'City',
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'select',
    label: 'State',
    question: 'State',
    name: 'StateOrProvince',
    options: [
      { value: 'AL', viewValue: 'Alabama' },
      { value: 'AK', viewValue: 'Alaska' },
      { value: 'AZ', viewValue: 'Arizona' },
      { value: 'AR', viewValue: 'Arkansas' },
      { value: 'CA', viewValue: 'California' },
      { value: 'CZ', viewValue: 'Canal Zone' },
      { value: 'CO', viewValue: 'Colorado' },
      { value: 'CT', viewValue: 'Connecticut' },
      { value: 'DE', viewValue: 'Delaware' },
      { value: 'DC', viewValue: 'District of Columbia' },
      { value: 'FL', viewValue: 'Florida' },
      { value: 'GA', viewValue: 'Georgia' },
      { value: 'GU', viewValue: 'Guam' },
      { value: 'HI', viewValue: 'Hawaii' },
      { value: 'ID', viewValue: 'Idaho' },
      { value: 'IL', viewValue: 'Illinois' },
      { value: 'IN', viewValue: 'Indiana' },
      { value: 'IA', viewValue: 'Iowa' },
      { value: 'KS', viewValue: 'Kansas' },
      { value: 'KY', viewValue: 'Kentucky' },
      { value: 'LA', viewValue: 'Louisiana' },
      { value: 'ME', viewValue: 'Maine' },
      { value: 'MD', viewValue: 'Maryland' },
      { value: 'MA', viewValue: 'Massachusetts' },
      { value: 'MI', viewValue: 'Michigan' },
      { value: 'MN', viewValue: 'Minnesota' },
      { value: 'MS', viewValue: 'Mississippi' },
      { value: 'MO', viewValue: 'Missouri' },
      { value: 'MT', viewValue: 'Montana' },
      { value: 'NE', viewValue: 'Nebraska' },
      { value: 'NV', viewValue: 'Nevada' },
      { value: 'NH', viewValue: 'New Hampshire' },
      { value: 'NJ', viewValue: 'New Jersey' },
      { value: 'NM', viewValue: 'New Mexico' },
      { value: 'NY', viewValue: 'New York' },
      { value: 'NC', viewValue: 'North Carolina' },
      { value: 'ND', viewValue: 'North Dakota' },
      { value: 'OH', viewValue: 'Ohio' },
      { value: 'OK', viewValue: 'Oklahoma' },
      { value: 'OR', viewValue: 'Oregon' },
      { value: 'PA', viewValue: 'Pennsylvania' },
      { value: 'PR', viewValue: 'Puerto Rico' },
      { value: 'RI', viewValue: 'Rhode Island' },
      { value: 'SC', viewValue: 'South Carolina' },
      { value: 'SD', viewValue: 'South Dakota' },
      { value: 'TN', viewValue: 'Tennessee' },
      { value: 'TX', viewValue: 'Texas' },
      { value: 'UT', viewValue: 'Utah' },
      { value: 'VT', viewValue: 'Vermont' },
      { value: 'VI', viewValue: 'Virgin Islands' },
      { value: 'VA', viewValue: 'Virginia' },
      { value: 'WA', viewValue: 'Washington' },
      { value: 'WV', viewValue: 'West Virginia' },
      { value: 'WI', viewValue: 'Wisconsin' },
      { value: 'WY', viewValue: 'Wyoming' },
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'text',
    label: 'Zip',
    question: 'Zip',
    name: 'PostalCode',
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'select',
    question: 'Which best describes this property?',
    name: 'OwnerScenario',
    note: 'Choose from the dropdown.',
    options: [
      {
        value: 'My Primary Residence',
        viewValue: 'My Primary Residence',
      },
      {
        value: 'An Investment Property',
        viewValue: 'An Investment Property',
      },
      {
        value: 'A Vacation Property',
        viewValue: 'A Vacation Property',
      },
      {
        value: 'Estate / Probate Sale',
        viewValue: 'Estate / Probate Sale',
      },
      {
        value: "I'm Helping A Family Member or Friend",
        viewValue: "I'm Helping A Family Member or Friend",
      },
      {
        value: 'A Lot',
        viewValue: 'A Lot',
      },
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'radio',
    question: 'Is the property currently listed on the MLS?',
    name: 'IsListed',
    note: 'Select Yes if the property is currently listed on a Multiple Listing Service (MLS), or No if it is not.',
    options: [
      {
        value: 'Yes',
        viewValue: 'Yes',
      },
      {
        value: 'No',
        viewValue: 'No',
      },
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'radio',
    question: 'Is the property currently listed in the FSBO section of Zillow?',
    name: 'IsZillow',
    note: 'Select Yes if you have created a For Sale By Owner (FSBO) profile on Zillow for this property, or No if you have not.',
    options: [
      {
        value: 'Yes',
        viewValue: 'Yes',
      },
      {
        value: 'No',
        viewValue: 'No',
      },
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'radio',
    question: 'Who is listed on the Title/Deed?',
    name: 'Dependent',
    options: [
      { viewValue: 'A Company', value: 'company' },
      { viewValue: 'One Person', value: 'onePeople' },
      { viewValue: 'Two People', value: 'twoPeople' },
      { viewValue: 'Other', value: 'other' },
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
    note: 'List all individuals or entities that appear on the Title/Deed. Note that anyone listed must sign a Listing Contract to access the MLS.',
  },

  {
    type: 'text',
    label: 'Legal Name of Company as written on Title?',
    name: 'CompanyTitle',
    note: 'If the property is owned by a company, enter the full legal name of the company exactly as it appears on the Deed.',
    value: '',
    showIf: { fieldName: 'Dependent', value: ['company'] },
    validations: [
      {
        name: 'required',
      },
      {
        name: 'regex',
        value: '^[A-Za-z\\s]+$',
        message:
          'Please enter a valid name using letters and spaces only, without special characters or numbers.',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'text',
    label: 'Company Signor Name',
    name: 'CompanySignorName',
    note: 'Enter the full name of the person who is legally authorized to sign on behalf of the company.',
    value: '',
    showIf: { fieldName: 'Dependent', value: ['company'] },
    validations: [
      {
        name: 'required',
      },
      {
        name: 'regex',
        value: '^[A-Za-z\\s]+$',
        message:
          'Please enter a valid name using letters and spaces only, without special characters or numbers.',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'text',
    label: 'Company Signor Title',
    name: 'CompanySignorTitle',
    value: '',
    note: 'Enter the official title of the company signor as it appears on the incorporation papers (e.g., Manager, Member, Principal, Owner, etc).',
    showIf: { fieldName: 'Dependent', value: ['company'] },
    validations: [
      {
        name: 'required',
      },
      {
        name: 'regex',
        value: '^[A-Za-z\\s]+$',
        message:
          'Please enter a valid name using letters and spaces only, without special characters or numbers.',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'text',
    label: 'Company Signor Email',
    name: 'CompanySignorEmail',
    value: '',
    note: 'Provide the email address of the person authorized to sign for the company.',
    showIf: { fieldName: 'Dependent', value: ['company'] },
    validations: [
      {
        name: 'required',
      },
      {
        name: 'regex',
        value:
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.(com|org|net|edu|gov|mil|co|io|us)$',
        message: 'Please enter a valid email address.',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'text',
    label: 'Full Name of First Person on the Title',
    name: 'FirstNameTitle',
    note: 'Enter the full legal name of the first person listed on the Title/Deed, exactly as it appears on the document.',
    showIf: { fieldName: 'Dependent', value: ['onePeople', 'twoPeople'] },
    validations: [
      {
        name: 'required',
      },
      {
        name: 'regex',
        value: '^[A-Za-z\\s]+$',
        message:
          'Please enter a valid name using letters and spaces only, without special characters or numbers.',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'text',
    label: 'Email of First Person on the Title',
    name: 'FirstNameEmail',
    note: 'Provide the email address of the first person listed on the Title/Deed.',
    showIf: { fieldName: 'Dependent', value: ['onePeople', 'twoPeople'] },
    validations: [
      {
        name: 'required',
      },
      {
        name: 'regex',
        value:
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.(com|org|net|edu|gov|mil|co|io|us)$',
        message: 'Please enter a valid email address.',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'text',
    label: 'Full Name of 2nd Person on the Title',
    name: 'SecondName',
    note: 'Enter the full legal name of the second person listed on the Title/Deed, exactly as it appears on the document.',
    showIf: { fieldName: 'Dependent', value: ['twoPeople'] },
    validations: [
      {
        name: 'required',
      },
      {
        name: 'regex',
        value: '^[A-Za-z\\s]+$',
        message:
          'Please enter a valid name using letters and spaces only, without special characters or numbers.',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'text',
    label: 'Email of Second Person on Title',
    name: 'SecondEmail',
    note: 'Provide the email address of the second person listed on the Title/Deed.',
    showIf: { fieldName: 'Dependent', value: ['twoPeople'] },
    validations: [
      {
        name: 'required',
      },
      {
        name: 'regex',
        value:
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.(com|org|net|edu|gov|mil|co|io|us)$',
        message: 'Please enter a valid email address.',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'text',
    label: 'Please List Name and E-mails of Anyone Listed On the Title/Deed',
    name: 'Other',
    note: 'List the full names and corresponding email addresses of all individuals or entities listed on the Title/Deed.',
    showIf: { fieldName: 'Dependent', value: ['other'] },
    validations: [
      {
        name: 'required',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'currency',
    question: 'Initial Listing Price',
    label: 'Listing Price ($)',
    name: 'ListPrice',
    note: 'Enter the initial listing price as a whole number without commas or dollar signs (e.g., 250000 for $250,000).',
    value: null,
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'radio',
    question: 'HOA or Condo association membership',
    name: 'CondoHoaStatus',
    note: 'Select Yes if the property is part of a Homeowners Association (HOA) or Condo Association, or No if it is not.',
    options: [
      {
        value: 'Yes',
        viewValue: 'Yes',
      },
      {
        value: 'No',
        viewValue: 'No',
      },
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'text',
    label: 'Name of Condo / HOA Association',
    name: 'CondoHoaName',
    note: 'If yes to HOA/Condo Association, enter the full name of the association.',
    showIf: { fieldName: 'CondoHoaStatus', value: ['Yes'] },
    validations: [
      {
        name: 'required',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'currency',
    label: 'Monthly Fees Amount ($)',
    name: 'CondoHoaMonthlyFee',
    note: 'If yes to HOA/Condo Association, enter the monthly fee amount as a whole number without dollar signs (e.g., 250 for $250).',
    showIf: { fieldName: 'CondoHoaStatus', value: ['Yes'] },
    validations: [
      {
        name: 'required',
      },
    ],
    isSubRequired: true,
  },

  {
    type: 'card',
    question: 'Property Type',
    label: 'Property Type',
    name: 'PropertySubType',
    note: 'Select the appropriate property type from the provided list (e.g., Single Family Home, Condo, Townhouse).',
    value: '',
    options: [
      {
        id: 1,
        title: 'HOUSE',
        src: '../../../assets/icons/house_icon.svg',
      },
      {
        id: 2,
        title: 'CONDO',
        src: '../../../assets/icons/condo_icon.svg',
      },
      {
        id: 3,
        title: 'CO-OP',
        src: '../../../assets/icons/co_op_icon.svg',
      },
      {
        id: 4,
        title: 'TOWNHOUSE',
        src: '../../../assets/icons/town_house_icon.svg',
      },
      {
        id: 5,
        title: 'DUPLEX/TRIPLEX',
        src: '../../../assets/icons/duplex_icon.svg',
      },
      {
        id: 6,
        title: 'LAND',
        src: '../../../assets/icons/land_icon.svg',
        showElse: {
          fieldName: 'OwnerScenario',
          value: ['My Primary Residence'],
        },
      },
      {
        id: 7,
        title: 'Other',
        src: '../../../assets/icons/other_icon.svg',
      },
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'rooms',
    question: 'Number of Bedrooms.',
    label: 'Bedrooms',
    name: 'BedroomsTotal',
    note: 'Enter the total number of bedrooms in the property as a whole number.',
    showElse: { fieldName: 'OwnerScenario', value: ['A Lot'] },
    options: [
      {
        id: 0,
        title: '0',
      },
      {
        id: 1,
        title: '1',
      },
      {
        id: 2,
        title: '2',
      },
      {
        id: 3,
        title: '3',
      },
      {
        id: 4,
        title: '4',
      },
      {
        id: 5,
        title: '5',
      },
      {
        id: 6,
        title: '6',
      },
      {
        id: 7,
        title: '7',
      },
      {
        id: 8,
        title: '8+',
      },
    ],
    value: '',
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'rooms',
    question: 'Number of Full Bathrooms',
    label: 'Full Bathrooms',
    name: 'BathroomsFull',
    note: 'Enter the number of full bathrooms (with toilet, sink, and shower/tub) as a whole number.',
    showElse: { fieldName: 'OwnerScenario', value: ['A Lot'] },
    options: [
      {
        id: 0,
        title: '0',
      },
      {
        id: 1,
        title: '1',
      },
      {
        id: 2,
        title: '2',
      },
      {
        id: 3,
        title: '3',
      },
      {
        id: 4,
        title: '4',
      },
      {
        id: 5,
        title: '5',
      },
      {
        id: 6,
        title: '6',
      },
      {
        id: 7,
        title: '7',
      },
      {
        id: 8,
        title: '8+',
      },
    ],
    value: '',
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'rooms',
    question: 'Number of Half Bathrooms',
    label: 'Half Bathrooms',
    name: 'BathroomsHalf',
    showElse: { fieldName: 'OwnerScenario', value: ['A Lot'] },
    note: 'A half bath, also known as a powder room, features a toilet and sink without bathing facilities.',
    options: [
      {
        id: 0,
        title: '0',
      },
      {
        id: 1,
        title: '1',
      },
      {
        id: 2,
        title: '2',
      },
      {
        id: 3,
        title: '3',
      },
      {
        id: 4,
        title: '4',
      },
      {
        id: 5,
        title: '5',
      },
      {
        id: 6,
        title: '6',
      },
      {
        id: 7,
        title: '7',
      },
      {
        id: 8,
        title: '8+',
      },
    ],
    value: '',
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'currency',
    question: 'Living Area',
    label: 'Living Area (Sq.ft)',
    name: 'LivingArea',
    showElse: { fieldName: 'OwnerScenario', value: ['A Lot'] },
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'chip-list',
    question: 'Heating',
    note: 'Select all applicable heating features for the property (e.g., Forced Air, Radiant, Heat Pump).',
    label: 'Heating',
    name: 'Heating',
    value: [],
    showElse: { fieldName: 'OwnerScenario', value: ['A Lot'] },
    options: [
      'NO HEATING',
      'Forced Air',
      'Baseboard',
      'Radiant',
      'Heat Pump',
      'Geothermal',
      'Boiler',
      'Electric',
      'Gas',
      'Oil',
      'Propane',
      'Wood Stove',
      'Pellet Stove',
      'Fireplace',
      'Solar',
      'Steam',
      'Hot Water',
      'Convection',
      'Ductless Mini-Split',
      'Gravity',
      'Wall Heater',
      'Ceiling Heat',
      'Zoned',
      'Furnace',
      'Passive Solar',
      'Radiant Floor',
      'Active Solar',
      'Central',
      'Coal',
      'Coal Stove',
      'ENERGY STAR/ACCA RSI Qualified Installation',
      'ENERGY STAR Qualified Equipment',
      'Exhaust Fan',
      'Fireplace Insert',
      'Floor Furnace',
      'Humidity Control',
      'Kerosene',
      'Natural Gas',
      'Radiant Ceiling',
      'See Remarks',
      'Space Heater',
      'Varies by Unit',
      'Wall Furnace',
      'Wood',
      'Other',
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'chip-list',
    question: 'Cooling',
    note: 'Select all applicable cooling features for the property (e.g., Central Air, Window Units, Evaporative Cooling).',
    label: 'Cooling',
    name: 'Cooling',
    value: [],
    showElse: { fieldName: 'OwnerScenario', value: ['A Lot'] },
    options: [
      'NO COOLING',
      'Central Air',
      'Window Units',
      'Ductless Mini-Split',
      'Heat Pump',
      'Evaporative Cooler (Swamp Cooler)',
      'Whole House Fan',
      'Attic Fan',
      'Geothermal',
      'Zoned',
      'Wall Units',
      'Ceiling Fan',
      'Dual',
      'Ductless',
      'Electric',
      'ENERGY STAR Qualified Equipment',
      'Exhaust Fan',
      'Gas',
      'Humidity Control',
      'Multi Units',
      'Roof Turbine',
      'Separate Meters',
      'Varies by Unit',
      'Wall/Window Unit',
      'Other',
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'chip-list',
    question: 'Basement',
    note: 'Select all features that accurately describe the basement of the property (e.g., Finished, Unfinished, Walkout).',
    label: 'Basement',
    name: 'Basement',
    value: [],
    showElse: { fieldName: 'OwnerScenario', value: ['A Lot'] },
    options: [
      'NO BASEMENT',
      'Crawl Space',
      'Full',
      'Partial',
      'Walkout',
      'Daylight',
      'Finished',
      'Unfinished',
      'Semi-finished',
      'Slab',
      'Garden level',
      'Lookout',
      'Cellar',
      'Bilevel',
      'Walkup',
      'English',
      'Egress',
      'Dugout',
      'Terrace level',
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'radio',
    question: 'Will you be purchasing another property?',
    name: 'BuyingNext',
    note: 'Indicate whether you plan to purchase another property after selling this one.',
    options: [
      {
        value: 'Yes',
        viewValue: 'Yes',
      },
      {
        value: 'No',
        viewValue: 'No',
      },
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'chip-list',
    label: 'Inclusions',
    name: 'Inclusions',
    value: [],
    question: 'Inclusions',
    showElse: { fieldName: 'OwnerScenario', value: ['A Lot'] },
    note: "Select all items that will be included in the sale of the property (e.g., appliances, fixtures, window treatments). If it's not included here the buyer may assume it's NOT included in the sale.",
    options: [
      'NO INCLUSIONS',
      'Light fixtures',
      'In - ground plants',
      'Curtains and drapes',
      'Built -in stereo speakers',
      'Surveillance equipment',
      'Propane tanks',
      'Solar panels',
      'Water softener',
      'Refrigerator',
      'Washer',
      'Dryer',
      'Microwave',
      'Dishwasher',
      'Oven / Range',
      'Freezer',
      'Wine cooler',
      'Ceiling fans',
      'Built -in shelving',
      'Built -in bookcases',
      'Alarm systems',
      'Smart home devices',
      'Blinds',
      'Shades',
      'Shutters',
      'Irrigation systems',
      'Outdoor lighting',
      'Outdoor kitchen equipment',
      'Fire pit',
      'Hot tub / spa',
      'Pool equipment',
      'Water filtration system',
      'Backup generator',
      'Garage door openers',
      'Storage sheds',
      'Workbenches',
      'Shelving units',
      'Mounted TVs',
      'Surround sound systems',
      'Intercom systems',
      'Built -in furniture',
      'Patio furniture',
      'Custom - made furniture',
      'Playground equipment',
      'Above - ground pool',
      'Gazebo',
      'Trampoline',
      'Window air conditioning units',
      'Portable heaters / coolers',
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'chip-list',
    label: 'Exclusions',
    name: 'Exclusions',
    value: [],
    question: 'Exclusions',
    showElse: { fieldName: 'OwnerScenario', value: ['A Lot'] },
    note: "Select all items that will be excluded from the sale of the property (e.g., personal items, specific fixtures). If it's not included here the buyer may assume it's included in the sale.",
    options: [
      'NO EXCLUSIONS',
      'Light fixtures',
      'In - ground plants',
      'Curtains and drapes',
      'Built -in stereo speakers',
      'Surveillance equipment',
      'Propane tanks',
      'Solar panels',
      'Water softener',
      'Refrigerator',
      'Washer',
      'Dryer',
      'Microwave',
      'Dishwasher',
      'Oven / Range',
      'Freezer',
      'Wine cooler',
      'Ceiling fans',
      'Built -in shelving',
      'Built -in bookcases',
      'Alarm systems',
      'Smart home devices',
      'Blinds',
      'Shades',
      'Shutters',
      'Irrigation systems',
      'Outdoor lighting',
      'Outdoor kitchen equipment',
      'Fire pit',
      'Hot tub / spa',
      'Pool equipment',
      'Water filtration system',
      'Backup generator',
      'Garage door openers',
      'Storage sheds',
      'Workbenches',
      'Shelving units',
      'Mounted TVs',
      'Surround sound systems',
      'Intercom systems',
      'Built -in furniture',
      'Patio furniture',
      'Custom - made furniture',
      'Playground equipment',
      'Above - ground pool',
      'Gazebo',
      'Trampoline',
      'Window air conditioning units',
      'Portable heaters / coolers',
    ],
    validations: [
      {
        name: 'required',
      },
    ],
    isRequired: true,
  },

  {
    type: 'textarea',
    question: 'Public Description',
    label: 'Public Description',
    name: 'PublicDescription',
    value: '',
    validations: [
      { name: 'maxlength', value: 3500 }, // Adding max length validation
      {
        name: 'required',
      },
    ],
    note: "Provide a compelling description of your property, highlighting its key features and unique selling points. Follow these guidelines: Adhere to Fair Housing laws and local MLS rules to avoid discriminatory language. Aim for about 3,500 characters (including spaces) to fit most MLS requirements. Focus on the property's best attributes, recent upgrades, and neighborhood amenities. Use clear, concise language and avoid excessive capitalization or punctuation. Include important details like square footage, lot size, and special features. Mention any recent renovations or energy-efficient upgrades. Describe the location and proximity to schools, shopping, or transportation. We'll review your description and suggest changes if needed to comply with MLS guidelines. Need inspiration? Check out the descriptions of homes already listed in your area on Zillow and other 3rd party sites. <b> Also, as per MLS and NAR guidelines, this description field may not contain contact information or commission details. Such content will be automatically removed </b>. Your description can be changed later.",
    hasShowMore: false,
    isRequired: true,
  },

  {
    type: 'textarea',
    question: 'Additional Information',
    label: 'Additional Information',
    name: 'Description',
    value: '',
    validations: [],
    note: "Use this space to provide any additional relevant information about the property or your selling situation that wasn't covered in the previous questions. This may include recent renovations, unique features, motivation for selling, or specific terms you're seeking.",
  },

  {
    type: 'text',
    question: 'Tax Id',
    label: 'TaxId',
    name: 'ParcelNumber',
    value: '',
    validations: [],
    note: '',
    display: false,
  },
];
